import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'MESSAGE',
  entryPoint: '/messages',
  collectionName: 'messages',
  querySearchListing: [
    ['folder', 'sender', 'recipient', 'subject', 'date', 'related_object_reference', 'read', 'pending', 'answered', 'forwarded'],
    { order: { date: 'desc' } }
  ],
  successMessageCreate: 'Message created',
  successMessageUpdate: 'Message updated',
  successMessageDelete: 'Message deleted',
});

export default {
  ...triggers,
  fetchMessages(dispatch, getState, params = {}) {
    const { selectedFolder, selectedFilter, search, page } = params;
    const conditions = {};
    if (selectedFolder) conditions.folder = selectedFolder;
    if (selectedFolder === 'inbox' || selectedFolder === 'notifications') {
      if (selectedFilter && selectedFilter !== 'all') {
        if (selectedFilter === 'unread') {
          conditions.read = false;
        }
        if (selectedFilter === 'toProcess') {
          conditions.pending = true;
        }
        if (selectedFilter === 'processed') {
          conditions.pending = false;
          conditions.read = true;
        }
      }
    }
    if (search) {
      conditions.$any = [
        { subject: { match: search } },
        { sender: { match: search } },
        { recipient: { match: search } },
      ];
    }
    const options = {};
    if (page) {
      options.offset = (config.NB_DISPLAYED_OBJECTS || 50) * (page - 1);
    }
    triggers.setData(dispatch, getState, { selectedFolder });
    return triggers.fetchListing(dispatch, getState, { selectedFilter, search, page, customQueryOptions: { where: conditions, ...options } });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/triggers.js